import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import {
  abortTextbookPdpChrome,
  armTextbookPdpChrome,
  finishTextbookPdpChrome,
} from './textbook-pdp-chrome-sync.js';

class ProductInventory extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (closestSection?.querySelector('.textbook-variant-picker')) {
      armTextbookPdpChrome(this);
    }
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateInventory);
    this.syncInventoryFromDisplayedOptions();
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateInventory);
  }

  updateInventory = (event) => {
    const closestSection = this.closest('.shopify-section, dialog');
    const textbook = closestSection?.querySelector('.textbook-variant-picker');

    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      if (textbook) abortTextbookPdpChrome(this);
      return;
    }

    if (textbook) {
      armTextbookPdpChrome(this);
    }

    const newInventory = event.detail.data.html.querySelector('product-inventory');

    if (!newInventory) {
      if (textbook) finishTextbookPdpChrome(closestSection, this);
      return;
    }

    morph(this, newInventory, { childrenOnly: true });
    this.syncInventoryFromDisplayedOptions();
  };

  /**
   * Textbook PDP: show in stock if any eligible variant is in stock. Eligible = Liquid rendered the
   * row (passed hide checks) — each `.accordion-variant-option` under the picker, on Print and Digital
   * tabs alike. A row with class `unavailable` is eligible but OOS. No dependency on active tab or
   * checkbox selection.
   */
  syncInventoryFromDisplayedOptions() {
    const closestSection = this.closest('.shopify-section, dialog');
    const picker = closestSection?.querySelector('.textbook-variant-picker');
    const gateVisibility = Boolean(picker);

    try {
      if (!closestSection) return;

      let renderedOptions;
      if (picker) {
        // All format panels live under the picker; hidden tabs still contain eligible rows in the DOM.
        renderedOptions = Array.from(picker.querySelectorAll('.accordion-variant-option'));
      } else {
        const activePanel = closestSection.querySelector('.format-tab-panel:not([hidden])');
        const searchRoot = activePanel || closestSection;
        renderedOptions = Array.from(searchRoot.querySelectorAll('.accordion-variant-option'));
      }

      if (renderedOptions.length === 0) return;

      const hasInStockAmongRendered = renderedOptions.some(
        (option) => !option.classList.contains('unavailable')
      );
      const status = hasInStockAmongRendered ? 'in_stock' : 'out_of_stock';
      const statusText = hasInStockAmongRendered ? 'In Stock' : 'Out of stock';
      const tooltipText = hasInStockAmongRendered
        ? 'In stock and ready to ship.'
        : 'Out of stock';

      const statusTextEl = this.querySelector('.product-inventory__text');
      if (statusTextEl) {
        statusTextEl.textContent = statusText;
        statusTextEl.classList.remove(
          'product-inventory__text-low',
          'product-inventory__text-in_stock',
          'product-inventory__text-out_of_stock'
        );
        statusTextEl.classList.add(`product-inventory__text-${status}`);
      }

      const tooltipEl = this.querySelector('.inventory-tooltip');
      if (tooltipEl) {
        tooltipEl.setAttribute('data-tooltip', tooltipText);
      }
    } finally {
      if (gateVisibility) {
        finishTextbookPdpChrome(closestSection, this);
      }
    }
  }
}

if (!customElements.get('product-inventory')) {
  customElements.define('product-inventory', ProductInventory);
}
